export default {
  title: 'Order details',
  order_again: 'Order Again',
};
